import * as React from "react";
import RichText from "../../utils/richText";
import Image from "../../images/image";
import Icon from "../../images/icons/icons";
import { getImageFromAuthorName } from "../../utils/manipulation";
import { navigate } from "gatsby";
import { SimpleCenteredBrand } from "../headers/simplecentered";
import ShareItOnSocial from "../share";
import useCTAMetadata from "./staticCTAData";
import * as cheerio from "cheerio";

function rewriteLinks(body) {
  const $ = cheerio.load(body, null, false);

  //open all links in new window
  $("a").map((i, val) => {
    return $(val).attr("target", "_blank");
  });

  return $.html();
}

export default function Blog({
  publishedDate,
  profilePicture,
  slug,
  author,
  body,
  isContentful,
  nodes,
  cta,
  returnUrl,
}) {
  const callToAction = useCTAMetadata();

  if (!isContentful) {
    body = rewriteLinks(body);
  }
  const backToBlog = () => {
    returnUrl ? navigate(`/${returnUrl}/blog`) : navigate("/blog/");
  };
  return (
    <>
      <div className="rounded-lg bg-white border overflow-hidden shadow mb-12">
        <div className="bg-white border-b border-gray-200 divide-x flex flex-row flex-wrap">
          <div className="p-4 p-4 flex items-center">
            <div className="flex items-center">
              <nav aria-label="Back to blog border-r-1">
                <div
                  onClick={backToBlog}
                  onKeyDown={backToBlog}
                  role="button"
                  tabIndex={0}
                  className="text-sm font-medium text-primary-500 cursor-pointer"
                >
                  Back to blog
                </div>
              </nav>
            </div>
          </div>
          <div className="p-4 flex flex-col sm:flex-row sm:flex-wrap sm:mt-0 sm:space-x-6 gap-2">
            <div className="flex items-center">
              <div className="flex items-center space-x-1 text-sm text-gray-500">
                <Icon iconName="Calendar" className="mr-1" />
                <time dateTime={publishedDate}>{publishedDate}</time>
              </div>
            </div>
            <div className="flex items-center">
              <div className="mr-2">
                <p className="text-sm font-medium text-gray-900 mb-0">by</p>
              </div>
              <div className="flex-shrink-0">
                {isContentful ? (
                  <Image
                    image={profilePicture}
                    alt={slug}
                    className="h-6 w-6 rounded-full"
                  />
                ) : (
                  <Image
                    image={getImageFromAuthorName(author, nodes)}
                    alt={author}
                    className="h-6 w-6 rounded-full"
                  />
                )}
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-900 mb-0">
                  {isContentful
                    ? author.firstName + " " + author.lastName
                    : author}
                </p>
              </div>
            </div>
          </div>
        </div>
        {isContentful ? (
          <div className="max-w-3xl prose mx-auto py-12 px-4 md:px-0">
            <RichText description={body} />
          </div>
        ) : (
          <div
            className="max-w-3xl prose mx-auto py-12 px-4 md:px-0"
            dangerouslySetInnerHTML={{ __html: body }}
          />
        )}
        {
          <div className="max-w-3xl mx-auto my-12 px-4 md:px-0">
            <SimpleCenteredBrand
              heading={isContentful ? cta.title : callToAction.title}
              description={
                isContentful ? cta.description : callToAction.description
              }
              primaryCtaText={
                isContentful ? cta.primaryCtaText : callToAction.primaryCtaText
              }
              primaryCtaLink={
                isContentful ? cta.primaryCtaLink : callToAction.primaryCtaLink
              }
              secondaryCtaText={
                isContentful
                  ? cta.secondaryCtaText
                  : callToAction.secondaryCtaText
              }
              secondaryCtaLink={
                isContentful
                  ? cta.secondaryCtaLink
                  : callToAction.secondaryCtaLink
              }
              bgClass="rounded-xl"
            />
          </div>
        }
        <ShareItOnSocial data={slug} />
      </div>
    </>
  );
}
